export class MontantAnnuel {

	public montantMiniAnnuel: number;

	public montantMaxiAnnuel: number;

	public devise: string;

	constructor() {
		 		this.montantMiniAnnuel = 0;
		this.montantMaxiAnnuel = 0;
		this.devise = '';

	}
}
